<template>
  <modal-layout :is-open="isOpen" @close="modalClose">
    <div :class="`Modal_area ${currentStep === 3 ? '_back-cl01' : ''}`">
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="ログを記録モーダルを閉じる"
        @click="modalClose"
      >
        <span class="Modal__cross" />
      </div>
      <div v-if="currentStep !== 3" class="Step__box Step__box--sm Step__box_modal">
        <div class="Step__head">
          Step
        </div>
        <div class="Step__circle_line">
          <div :class="`Step__circle  ft_en ${setStepActive(1)}`">
            <span>1</span>
          </div>
        </div>
        <div class="Step__circle_line">
          <div :class="`Step__circle  ft_en ${setStepActive(2)}`">
            <span>2</span>
          </div>
        </div>
      </div>
      <!-- <div class="Modal_title">{{ day }}</div> -->
      <div v-if="currentStep !== 3" class="Modal_title">
        <span class="Modal_title_date">{{ handleDateHead() }}</span>
      </div>
      <log-write-modal-step-1
        v-if="currentStep === 1"
        :step="currentStep"
        :heart="heartRate"
        :health="healthStatus"
        @changeStep1="changeStep1"
      />
      <log-write-modal-step-2
        v-if="currentStep === 2"
        :step="currentStep"
        :meditation="full_time"
        :listzoomlogs="listZoom"
        :listmelonlogs="listMelonLog"
        :diary="diary"
        :timemeditation="timeMeditation"
        @changeStep2="changeStep2"
      />
      <log-write-modal-step-3
        v-if="currentStep === 3"
        :step="currentStep"
        @changeStep="changeStep"
        @modalClose="modalClose"
      />
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout.vue'
import LogWriteModalStep1 from './LogWriteModal/LogWriteModalStep1.vue'
import LogWriteModalStep2 from './LogWriteModal/LogWriteModalStep2.vue'
import LogWriteModalStep3 from './LogWriteModal/LogWriteModalStep3.vue'
import 'vue-slider-component/theme/antd.css'
import LogStore from '@/services/logService'
import moment from 'moment'
import melonLogService from '@/services/melonLogService'
import zoomLogService from '@/services/zoomLogService'

export default {
  name: 'LogWriteModal',
  components: {
    ModalLayout,
    LogWriteModalStep1,
    LogWriteModalStep2,
    LogWriteModalStep3
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    createTime: {
      type: String,
      default: null
    },
    day: { // from log
      type: String,
      default: null
    },
    today: { // from mindfullLog
      type: String,
      default: null
    }
  },
  data() {
    return {
      currentStep: 1,
      isOpenWriteStep2: false,
      heartRate: 5,
      healthStatus: 5,
      meditation: null,
      diary: null,
      created_at: moment(new Date()).format('YYYY-MM-DD'),
      meditationMelontv: null,
      full_time: 0,
      listZoom: [],
      listMelonLog: [],
      getDay: '',
      getToday: '',
      timeMeditation: 0
    }
  },
  watch: {
    getToday: function() {
      if (this.getToday !== null) {
        LogStore.getToday().then(result => {
          if (result.data[0]) {
            this.heartRate = result.data[0].heart_beat_rate
            this.healthStatus = result.data[0].health_state
            this.diary = result.data[0].diary
            this.timeMeditation = result.data[0].meditation_time
          }
        })
      }
    },
    getDay: function() {
      if (this.getDay !== undefined) {
        this.getDataLog(this.getDay)
        // zoomLogService.getTime(this.getDay).then(result => {
        //   this.listZoom = result.data
        //   this.full_time = result.time
        // })
        // melonLogService.getTime(this.getDay).then(result => {
        //   this.listMelonLog = result.data
        //   this.full_time += result.time
        // })
      }
    }
  },
  updated() {
    this.getToday = this.day ? this.day : this.today
    this.getDay = this.day ? this.day : (this.createTime) ? this.createTime : this.today
  },
  methods: {
    setStepActive(step) {
      return this.currentStep === step ? 'Step__circle--active' : ''
    },
    changeStep1(step, heart, health) {
      this.currentStep = step
      this.heartRate = heart
      this.healthStatus = health
    },
    changeStep2(step, meditat, logs, medita_melontv) {
      this.currentStep = step
      this.meditation = meditat
      this.diary = logs
      this.meditationMelontv = Number(medita_melontv)
      this.storeDiary()
    },
    changeStep(step) {
      this.currentStep = step
    },
    async storeDiary() {
      if (this.createTime !== null) {
        this.created_at = this.createTime
      }
      const data = {
        heart_beat_rate: this.heartRate,
        health_state: this.healthStatus,
        meditation_time: this.meditation,
        diary: this.diary,
        created_at: this.created_at,
        meditation_melontv: this.meditationMelontv
      }
      const record = {
        old_meditation: this.timeMeditation,
        total_meditation_time: this.meditation
      }
      await LogStore.store(data)
      await LogStore.updateLog(record)
    },
    resetModal() {
      this.currentStep = 1
    },
    modalClose(type) {
      type = (type === 'updated') || (this.currentStep === 3) ? 'updated' : 'close'
      this.$emit('close', type)
      this.resetModal()
      if (type === 'close') {
        this.heartRate = 5
        this.healthStatus = 5
      }
    },
    nextStep() {
      this.isOpenWriteStep2 = true
    },
    handleDateHead() {
      if (this.createTime) {
        return moment(this.createTime).format('YYYY.MM.DD (ddd)')
      }
      return moment(this.created_at).format('YYYY.MM.DD (ddd)')
    },
    async getDataLog(day) {
      await zoomLogService.getTime(day).then(result => {
        this.listZoom = result.data
        this.full_time = result.time
      })
      await melonLogService.getTime(day).then(result => {
        this.listMelonLog = result.data
        this.full_time += result.time
      })
    }
  }
}
</script>
